export default __webpack_public_path__ + "static/media/iphone-8.281d6b2a.png";